<template>
    <div>
        <v-dialog max-width="800px" persistent v-model="showObservationModal" @close="close">
            <v-card flat>

                <v-card-title>
                    <span class="headline">Observação</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="observation"
                                    outline
                                    rows=3
                                    label="Observação(opcional)"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>


                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading">
                        <v-btn ma-2 depressed @click="close">Cancelar</v-btn>
                        <v-btn ma-2 color="primary" @click="save">Concluir</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "ObservationModal",
        data(){
            return {
                observation: '',
            }
        },

        props: {
            loading: {
                type: Boolean,
                default: false,
            }
        },

        methods: {
            save(){
                this.$emit('onSave', this.observation);
            },
            close(){
                this.observation = '';
                this.showObservationModal = false;
            }
        },
        computed: {
            showObservationModal: {
                get(){
                    return this.$store.getters.getShowObservationModal;
                },
                set(value){
                    this.$store.dispatch('setShowObservationModal', value);
                }
            }
        }
    }
</script>

<style scoped>

</style>